import './Header.css';

export default function Header() {
  return (
    <>
      <div className="header">

      </div>
    </>
  );
}